import React, { useEffect, useState } from "react";
import styles from "./mobile-property-features.module.scss";
import { MobilePropertyFeaturesProps } from "./mobile-property-features.interface";
import FeaturesTag from "../../features-tag";
import ButtonC from "../../button";
import { numberWithCommas } from "../../../../utils/const";
import { SeeAllFeatures } from "../../../investor/amplitude";
import { useParams, useSearchParams } from "react-router-dom";
import useContextHook from "../../../../hooks/context/useContext";

const MobilePropertyFeatures = ({
  title,
  objPropertyDetails,
  minShowData,
  maxShowData,
  type
}: MobilePropertyFeaturesProps) => {
  const { propertyId } = useParams();
  const { mobileNumber } = useContextHook();
  const [searchParams] = useSearchParams();
  const cid = searchParams.get("cid") || "";
  const eq = searchParams.get("eq") || "";
  const featuresArray = [
    {
      id: 1,
      num: objPropertyDetails?.beds || objPropertyDetails?.bedRooms,
      label: "Bedroom",
      icon: "/images/bath.svg"
    },
    {
      id: 2,
      num: objPropertyDetails?.baths || objPropertyDetails?.totalBath,
      label: "Bathroom",
      icon: "/images/bed.svg"
    },
    {
      id: 3,
      num: numberWithCommas(objPropertyDetails?.sqft || 0),
      label: " ft²",
      icon: "/images/tape.svg"
    },
    {
      id: 4,
      num: numberWithCommas(objPropertyDetails?.lotSizeSqFt || 0),
      label: " Lot Size",
      icon: "/images/tape.svg"
    },
    {
      id: 5,
      num: objPropertyDetails?.yearBuilt,
      label: `Built in `,
      icon: "/images/calendar.svg"
    },
    {
      id: 6,
      num: objPropertyDetails?.possession,
      label: "",
      icon: "/images/vacant.svg"
    },
    {
      id: 7,
      num: objPropertyDetails?.occupancy,
      label: "",
      icon: "/images/vacant.svg"
    },
    // {
    //   id: 8,
    //   url: objPropertyDetails?.images?.find(
    //     (obj: { type: string; url: string }) => {
    //       if (obj.type === "inspection") {
    //         return obj?.url;
    //       }
    //     }
    //   ),
    //   num: null,
    //   label: "Inspection",
    //   icon: "/images/note.svg"
    // },
    // {
    //   id: 9,
    //   url: objPropertyDetails?.images?.find(
    //     (obj: { type: string; url: string }) => {
    //       if (obj.type === "disclosure") {
    //         return obj?.url;
    //       }
    //     }
    //   ),
    //   num: null,
    //   label: "Disclosures",
    //   icon: "/images/disclosures.svg"
    // },
    {
      id: 8,
      url: objPropertyDetails?.images?.find(
        (obj: { type: string; url: string }) => {
          if (obj.type === "inspection") {
            return obj?.url;
          }
        }
      ),
      num: null,
      label: "Inspection",
      icon: "/images/note.svg"
    },
    {
      id: 9,
      url: objPropertyDetails?.images?.find(
        (obj: { type: string; url: string }) => {
          if (obj.type === "disclosure") {
            return obj?.url;
          }
        }
      ),
      num: null,
      label: "Disclosures",
      icon: "/images/disclosures.svg"
    },
    {
      id: 10,
      num: objPropertyDetails?.propertyAccess,
      label: "",
      icon: "/images/propertyAccess.svg"
    }
  ];
  const [showMore, setShowMore] = useState(false);
  const [featData, setFeatData] = useState(() => featuresArray);

  useEffect(() => {
    let _featuresArray;
    if (showMore) {
      _featuresArray = featuresArray?.slice(0, maxShowData);
      setFeatData(_featuresArray);
    } else {
      _featuresArray = featuresArray?.slice(0, minShowData);
      setFeatData(_featuresArray);
    }
  }, [objPropertyDetails]);
  function showFeature() {
    setShowMore((prev) => !prev);
    let _featuresArray;
    if (!showMore) {
      _featuresArray = featuresArray?.slice(0, maxShowData);
      setFeatData(_featuresArray);
    } else {
      _featuresArray = featuresArray?.slice(0, minShowData);
      setFeatData(_featuresArray);
    }
  }

  return (
    <div className={styles.propertyFeatures} tabIndex={16}>
      <div className={styles.title} tabIndex={17}>
        {title}
      </div>

      <div className={styles.featuresWrap}>
        {featData?.map((feat: any, index: number) => {
          return (
            <React.Fragment key={index}>
              <>
                {feat?.num && (
                  <FeaturesTag
                    value={feat?.num}
                    label={feat?.label}
                    images={feat?.icon}
                    url={feat?.url}
                  />
                )}
              </>
            </React.Fragment>
          );
        })}
        {/* {minShowData && featData?.length > mamShowData && ( */}
        <ButtonC
          type="button"
          btnType="link"
          label={showMore ? "See Less" : "See All"}
          onClick={() => {
            showFeature();
            if (type === "investor") {
              SeeAllFeatures({
                buttonLabel: showMore ? "See Less" : "See All",
                propertySFID: objPropertyDetails?.propertySFID,
                propertyId: objPropertyDetails?.propertyId,
                shareId: propertyId || "",
                pubPropertySFID: objPropertyDetails?.pubPropertySFID,
                opportunitySFID: objPropertyDetails?.opportunitySFID,
                linkCId: cid,
                linkEmailId: eq,
                ...(mobileNumber && { mobileNumber: mobileNumber })
              });
            }
          }}
          className={styles.link}
          tabIndex={25}
        />
        {/* )} */}
      </div>
    </div>
  );
};

export default React.memo(MobilePropertyFeatures);
